import React from 'react';
import TimeAgo from 'react-timeago';

export const WorkspaceTemplateUpdatedAt = ({
  updatedAt,
}: {
  updatedAt: string | undefined | null;
}) => {
  if (updatedAt == null) {
    return null;
  }

  return (
    <div className="text-sm font-normal text-moon-500">
      Last updated <TimeAgo date={updatedAt} />
    </div>
  );
};
